import PuzzleService from '_services/rest/modules/puzzle';

export default {
  state: {
    puzzleWalls: null,
    hasChanges: false,
  },
  mutations: {
    setPuzzleWalls(state, puzzleWalls) {
      state.puzzleWalls = puzzleWalls;
    },
    setHasChanges(state, status) {
      state.hasChanges = status;
    },
  },
  actions: {
    setPuzzleWalls({ commit }, model) {
      commit('setPuzzleWalls', model);
    },
    setHasChanges({ commit }, status) {
      commit('setHasChanges', status);
    },
    getPuzzleWalls({ commit }, id) {
      PuzzleService.getPuzzleById(id)
        .then(response => {
          commit('setPuzzleWalls', response);
          commit('setHasChanges', false);
        });
    },
  },
};
